import React from 'react';
import themePrimary from '../../../styles/themePrimary';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { IconButton as MatIconButton } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import { ElementDimensions } from '../../../styles/ElementDimensions';
import { CheckOutStateContext } from '../../../providers/CheckOutStateContextProvider';
import { Skin } from '../../../models/common/Skin';

const useStyles = makeStyles({
    root: {

    },
    button: {
        backgroundColor: props => (props as Skin).primary_main_color,
        color: themePrimary.palette.primary.contrastText,
        textAlign: 'center',
        borderRadius: '23px',
        height: '46px',
        width: '60px',             
    },
    icon: {
        height: '30px',
        width: '30px',
    },
});

const RefreshButtonInternal = withStyles((themePrimary) => ({
  root: {
    borderRadius: '50%',
    boxShadow: 'none',
    fontSize: themePrimary.typography.h5.fontSize,

  },
  label: {
      fontSize: '1rem',
  }
}))(MatIconButton);

export type RefreshButtonClickHandler = (event: React.MouseEvent<HTMLElement>) => any;

export interface RefreshButtonProps {
    disabled: boolean
    onClickHandler: RefreshButtonClickHandler
}

export default function RefreshButton(props: RefreshButtonProps) {
    const { disabled, onClickHandler } = props;
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    return (
        <div className={classes.root}>
            <div className={classes.button}>
                <RefreshButtonInternal
                    disabled={disabled}
                    onClick={onClickHandler}
                    className={classes.button}>
                    <div>
                        <RefreshIcon className={classes.icon}/>
                    </div>
                </RefreshButtonInternal>
            </div>
        </div>
    );
}